/* eslint react/prop-types: 0 */
// Display refund tracker and provide mounting point in the Channel Steering upfront faq page
import React from 'react';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { HcRefundsTracker } from '@paypalcorp/helpcomponents';
import ColGrid from '../components/ColGrid';
import { isCsHelpRefundTrackerEnabled } from '../../lib/TrackersHelper';
import { pageNames } from '../../lib/page-name-identifiers';

// Display refund tracker within refund topic; HARDCODE refund tracker display condition
const REFUND_REFID = 'refunds_l2';

const UpfrontTracker = function (props) {
  const { topicSelect, selectResult } = props;

  if (_isEmpty(selectResult) || !topicSelect || !topicSelect.topicRef || topicSelect.topicRef.layer2 !== REFUND_REFID) {
    return null;
  }

  const renderTracker = () => {
    if (isCsHelpRefundTrackerEnabled()) {
      return (
        <HcRefundsTracker
          componentName="smarthelpnodeweb"
          fptiOptions={{
            page: pageNames.refundsTrackerContactUs.pageName,
            pgrp: pageNames.refundsTrackerContactUs.pageGroupName,
          }}
        />
      );
    }

    return null;
  };

  return <ColGrid>{renderTracker()}</ColGrid>;
};

function mapStateToProps(state) {
  return {
    topicSelect: state.topicSelect,
    selectResult: state.selectResult.topicTreeSelectResult,
  };
}

export default connect(mapStateToProps, null)(UpfrontTracker);
